<template>
  <button type="button"
    class="btn btn-link btn-wide"
    v-on:click="postMessageToWindow"
    tabindex="1">
    <slot></slot>
  </button>
</template>

<script>
import postMessageToWindow from '@/api/postMessageToWindow';

/**
 * Transition Button
 *
 * A common transition link button, useful for forms.
 */
export default {
  name: 'TransitionButton',
  methods: {
    /**
     * Posts continue to ocr message to parent window on button click
     */
    postMessageToWindow() {
      const data = {
        close: true,
        reason: 'ocr',
        data: {
          hasShippingData: this.$store.state.hasShippingData,
        },
      };
      postMessageToWindow(data);
    },
  },
};
</script>
